import { Button } from '@timelyapp/react';
import classNames from 'classnames';
import Input from 'components/Input';
import InputLabel from 'components/InputLabel';
import { InputValidation } from 'components/InputValidation';
import config from 'config';
import React, { useState } from 'react';
import sharedStyles from 'routes/auth/AuthPage.module.scss';
import AuthPageLayout from 'routes/auth/AuthPageLayout';
import OrDivider from 'routes/auth/OrDivider';
import SsoButtons from 'routes/auth/SsoButtons';
import styles from './SignupRoute.module.scss';

const errorHandler = (errors: Record<'email' | 'name' | 'password', Array<string>>) => {
  const { email = [], name = [], password = [] } = errors;

  return {
    email: email[0] ? email[0].replace(/&#39;/g, "'") : undefined,
    name: name[0] ? name[0].replace(/&#39;/g, "'") : undefined,
    password: password[0] ? password[0].replace(/&#39;/g, "'") : undefined,
  };
};

const SignupRoute: React.FC = () => {
  const [nameInput, setNameInput] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const { email, name, password } = errorHandler(
    window.BOOTSTRAPPED_DATA?.registration_form_errors
  );

  return (
    <AuthPageLayout
      title={
        <>
          Sign up to Timely <br /> No credit card required
        </>
      }
      bottomLink={
        <>
          Already have an account? &nbsp;{' '}
          <a
            href={`${window.BOOTSTRAPPED_DATA.auth_host || window.BOOTSTRAPPED_DATA.host}/login`}
            data-testid="log_in_link"
          >
            Log in
          </a>
        </>
      }
    >
      <SsoButtons action="Sign up" testIdPrefix="signup" />
      <OrDivider />
      <div className={sharedStyles.formInputs}>
        <form
          id="new_registration_form"
          action="/registration"
          method="post"
          data-hs-cf-bound="true"
        >
          <input
            type="hidden"
            name="authenticity_token"
            value={
              window.BOOTSTRAPPED_DATA.authencity_token ??
              window.BOOTSTRAPPED_DATA.authenticity_token
            }
          />
          <div className={sharedStyles.inputContainer}>
            <InputValidation style={{ margin: '0 0 10px' }} validationError={email}>
              <Input
                className="fs-mask"
                type="email"
                name="registration_form[email]"
                value={emailInput}
                onChange={event => setEmailInput(event.currentTarget.value)}
                data-testid="email_input"
              />
            </InputValidation>
            <InputLabel className={classNames({ [sharedStyles.activeLabel]: emailInput })}>
              Work email
            </InputLabel>
          </div>
          <div className={sharedStyles.inputContainer}>
            <InputValidation style={{ margin: '0 0 10px' }} validationError={name}>
              <Input
                value={nameInput}
                onChange={event => setNameInput(event.currentTarget.value)}
                className="fs-mask"
                type="text"
                name="registration_form[name]"
                data-testid="name_input"
              />
            </InputValidation>
            <InputLabel className={classNames({ [sharedStyles.activeLabel]: nameInput })}>
              Full name
            </InputLabel>
          </div>
          <div className={sharedStyles.inputContainer}>
            <InputValidation style={{ margin: '0 0 10px' }} validationError={password}>
              <Input
                className="fs-mask"
                type="password"
                name="registration_form[password]"
                autoComplete="new-password"
                value={passwordInput}
                onChange={event => setPasswordInput(event.currentTarget.value)}
                data-testid="password_input"
              />
            </InputValidation>
            <InputLabel className={classNames({ [sharedStyles.activeLabel]: passwordInput })}>
              Password
            </InputLabel>
          </div>
          <div className={styles.tos}>
            By signing up you agree to our{' '}
            <a
              href={config.termsOfServiceUrl}
              target="_blank"
              rel="noopener"
              data-testid="terms_of_service_link"
            >
              Terms of Service
            </a>
          </div>
          <Button
            data-auth="memory"
            type="submit"
            className={sharedStyles.submitButton}
            priority="xhigh"
            size="large"
            data-testid="start_free_trial_button"
          >
            Start 14-day free trial
          </Button>
        </form>
      </div>
    </AuthPageLayout>
  );
};

export default SignupRoute;
